"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _numeral = _interopRequireDefault(require("numeral"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// NUMBER FORMATTING
var NumberUtils = function NumberUtils() {
  _classCallCheck(this, NumberUtils);
};

exports.default = NumberUtils;

_defineProperty(NumberUtils, "formatNumber", function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,00';
  return value ? (0, _numeral.default)(value).format(format) : '-';
});

_defineProperty(NumberUtils, "formatWithMonth", function (value) {
  var readableValue;

  if (isNaN(value)) {
    readableValue = value;
  } else {
    readableValue = value === '1' ? '1 month' : "".concat(value, " months");
  }

  return readableValue;
});
//# sourceMappingURL=NumberUtils.js.map